import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=5674913d&scoped=true&"
import script from "./UpdateDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDetail.vue?vue&type=style&index=0&id=5674913d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674913d",
  null
  
)

export default component.exports